"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Sidebar/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _myRelations = require('shared/selectors/myRelations');
var _session = require('shared/selectors/session');
var _hooks = require('web/services/hooks');

var _List = require('web/screens/App/List');
var _BroadcastListHeader = require('./BroadcastListHeader'); var _BroadcastListHeader2 = _interopRequireDefault(_BroadcastListHeader);
var _CampaignsList = require('./CampaignsList'); var _CampaignsList2 = _interopRequireDefault(_CampaignsList);
var _ListMenuNotice = require('web/components/Upsells/ListMenuNotice'); var _ListMenuNotice2 = _interopRequireDefault(_ListMenuNotice);








const BroadcastSidebar = ({ hasFeature, lockedNotice }) => {
  const canCreate = hasFeature && !lockedNotice
  const doIHaveAnyPhoneTeams = _hooks.useAppSelector.call(void 0, _myRelations.selectDoIHaveAnyPhoneTeams)
  const selectedTeamKey = _hooks.useAppSelector.call(void 0, state => _session.selectSelectedTeamKey.call(void 0, state) || null)

  return (
  _react2.default.createElement(_List.List, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
    , _react2.default.createElement(_BroadcastListHeader2.default, {
      selectedTeamKey: selectedTeamKey,
      onSelectTeam: _actions2.default.setSelectedTeam,
      onCreateNewCampaign: _actions2.default.gotoNewCampaign,
      doIHaveAnyPhoneTeams: doIHaveAnyPhoneTeams,
      hasFeature: canCreate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
    )
    ,  hasFeature && lockedNotice 
    ,  hasFeature
      ? _react2.default.createElement(_CampaignsList2.default, { teamKey: selectedTeamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}} )
      : _react2.default.createElement(_ListMenuNotice2.default, {
          desc: "Upgrade to send campaign messages."    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
        )
    
  )
  )
}

exports. default = _react.memo.call(void 0, BroadcastSidebar)
